var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Link } from 'react-router-dom';
var Wrapper = function (props) {
    if (props.type === 'a') {
        if (props.content.href && props.content.href.indexOf('http') === 0) {
            return (React.createElement("a", { className: props.content.className, href: props.content.href, target: "_blank", rel: "noopener" }, props.children));
        }
        return (React.createElement(Link, { className: props.content.className, to: props.content.href || '', onClick: props.handleClick }, props.children));
    }
    return (React.createElement("div", __assign({}, props.content, { onClick: props.handleClick }), props.children));
};
export default Wrapper;
//# sourceMappingURL=Wrapper.js.map